import React from "react";
import { useTranslation } from "react-i18next";
import useQuoteRegion from "../hooks/useQuoteRegion";

/**
 * 국내 접속에만 보여주는 감싸개 (설계 4).
 *
 * 해외배송을 하지 않으므로 주문·견적은 메뉴에서 빼고, 주소로 직접 들어온 경우
 * (네이버 스마트스토어의 ?return= 링크·북마크·공유 링크)에만 한 줄로 안내한다.
 */
export default function RegionOnly({ children }) {
  const { t } = useTranslation();
  const allowed = useQuoteRegion();

  // 확인 중에는 화면을 흔들지 않는다
  if (allowed === null) return null;

  if (!allowed) {
    return (
      <p style={{ padding: "80px 20px", textAlign: "center", wordBreak: "keep-all" }}>
        {t("quote.regionOnly", "이 서비스는 국내에서만 이용하실 수 있습니다.")}
      </p>
    );
  }

  return children;
}
